import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { BiEvent } from '@wix/da-bi/pkg/events';

import s from './Attribution.scss';

export interface Props {
  author?: PapiUser;
  relatedItemBiData?: BiEvent;
  className?: string;
  showAuthorTooltip?: boolean;
  showAuthorName?: boolean;
  showAvatar?: boolean;
  avatarSize?: number;
  userlinkClassName?: string;
}

const Attribution: React.FC<Props> = ({
  author,
  relatedItemBiData,
  className,
  avatarSize = 25,
  showAvatar = true,
  showAuthorTooltip,
  showAuthorName = true,
  userlinkClassName,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(s['attribution'], !showAvatar && s['no-avatar'], className)}>
      {author && (
        <>
          {showAvatar && (
            <UserAvatar
              size={avatarSize}
              className={s['avatar']}
              user={author}
              withTooltip={showAuthorTooltip}
              relatedItemBiData={relatedItemBiData}
              aria-label={author.username}
            />
          )}
          {!showAvatar && <>{t('deviationview.overlay.by')}&nbsp;</>}
          {showAuthorName && (
            <UserLink
              className={classnames(s['user-link'], userlinkClassName)}
              user={author}
              withTooltip={showAuthorTooltip}
              biData={{
                creatorid: author.useridUuid,
              }}
              relatedItemBiData={relatedItemBiData}
            />
          )}
        </>
      )}
    </div>
  );
};
Attribution.displayName = 'Attribution';

export default Attribution;
